export const SET_CURRENT_MENU = 'setCurrentMenu'
export const TOGGLE_LNB = 'toggleLnb'
export const SET_IS_POOQ_ZONE = 'setIsPooqZone'
export const SET_START_TRASITION = 'setStartTransition'
export const SET_END_TRASITION = 'setEndTransition'

export const SET_FILTER = 'setFilter'
export const SET_FILTER_OBJECT = 'setFilterObject'
export const SET_FILTER_LIST = 'setFilterList'
export const SET_SHOW_FILTER = 'setShowFilter'

export const SET_MULTIBANNER_INFO = 'setMultiBannerInfo'

export const SET_MULTI_BANNER_LIST = 'setMultiBannerList'
export const SET_GNB_INFO_BY_MENU_NAME = 'setGNBINfoByMenuName'

export const SET_USER_LOGIN_INFO = 'setUserLoginInfo'
